module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAADeSURBVHjarNK9DcIwEIbh97AnooQNGAZRIQoaKIgSChK2gN4egQohKqjYBOloEhSZ/DgSJ7nx2Y+s8yeqyj9qxJ9qBODFvrzYJPaSFyte7MGLfYQvOgMrLzaLQYACWACnb0NVUVUcJnMYdZis2guXw4jDHMtzm3ovPNiKdSE/UBvWhzRCIRaDtEIBdutDVBVpC2T5O1dgDFxm+p4ODmSJ5BUCTLzYdBBUQ+bAtnzJHlh2Yg1fXDTNpDaztHPYXUgMFp2TvtBWzTwGacB2IfR0mHUMUsMSh7n35mhofQYA48XUX9SIfhAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.png
// module id = q6r7
// module chunks = 5